import React, { FunctionComponent } from "react";

import { bemClassNames, TAB_INDEX_FOCUSABLE_ONLY, TAB_INDEX_FOCUSABLE_TAB_SEQUENCE } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { Role } from "@multiweb/uiShared/Role";
import { Icon, IconColor, IconSize } from "../Icon";
import { FlexDirection, FlexGrow, JustifyContent, Layout } from "../Layout";
import { Text } from "../Text";
import { AlignItems, FakeComponentProps } from "../types";

export type ImageEditFakeComponentProps = {
    /** Text zobrazovaný v komponentě */
    value: string;
} & FakeComponentProps;

const classNames = bemClassNames("image-edit-fake-component");

/** ImageEditFakeComponent obsahující ikonu a text. Komponenta se podobá ImageFake komponentě ve stavu, kdy nění vybrán obrázkový formát souboru. */
export const ImageEditFakeComponent: FunctionComponent<ImageEditFakeComponentProps> = ({
    value,
    onClick,
    onKeyDown,
    label,
    title,
    disabled,
    valueTitle,
    isEditing,
    ariaLabelledBy,
}) => (
    <Layout flexGrow={FlexGrow.one} alignItems={AlignItems.flexStart} justifyContent={JustifyContent.center}>
        <div
            className={classNames()}
            tabIndex={TAB_INDEX_FOCUSABLE_ONLY} // Nutné kvůli zaměření myší, aby se uživatel nemusel trefovat přímo do textu.
            {...{ title, onClick, onKeyDown }}
        >
            <Layout alignItems={AlignItems.center} justifyContent={JustifyContent.center} flexDirection={FlexDirection.column} flexGrow={FlexGrow.one} >
                <Icon disabled={disabled || !isEditing} iconCode={IconCode.docImage} size={IconSize.large} title={valueTitle} color={IconColor.blackFixed}/>
                <div className={classNames("textDiv")}>
                    <Text
                        value={value}
                        disabled={disabled || !isEditing}
                        title={valueTitle}
                        hideOutlineOnFocus={true}
                        tabIndex={TAB_INDEX_FOCUSABLE_TAB_SEQUENCE}
                        role={Role.button}
                        ariaLabelledBy={ariaLabelledBy}
                        ariaLabel={label}
                    />
                </div>
            </Layout>
        </div>
    </Layout>
);
